import DescriptionIcon from "@mui/icons-material/Description";
import { EmployeeServicePath, BUSINESS_TRIP_REPORTS } from "utils/constants";
import BusinessTripReportsPage from "./Page";

export const resources = {
  isMenu: true,
  icon: <DescriptionIcon />,
  name: EmployeeServicePath + BUSINESS_TRIP_REPORTS,
  title: "Бланки за командировки",
  custom: <BusinessTripReportsPage />,
};
